module.exports = __webpack_public_path__ + "static/img/minicon1.7b6b05f9.png";